import request from "@/utils/request";

export function login(params) {
  return request({
    url: "/api/web/user/login",
    method: "post",
    data: params
  });
}

export function getCurtUser(params) {
  return request({
    url: "/api/system/shopUser/getShopUser",
    method: "post",
    data: params
  });
}

export function register(params) {
  return request({
    url: "/api/web/user/register",
    method: "post",
    data: params
  });
}

export function getCurrentUser(params) {
  return request({
    url: "/api/web/user/getCurrentUser",
    method: "post",
    data: params
  });
}

export function logout(params) {
  return request({
    url: "/api/web/user/logout",
    method: "post",
    data: params
  });
}

//获取手机验证码
export function getNOteCode(params) {
  return request({
    url: "/api/web/user/getNOteCode",
    method: "post",
    data: params
  });
}
//微信授权登录
export function wxlogin(params) {
  return request({
    url: "/api/system/wx/wx/login",
    method: "get",
    data: params
  });
}
//绑定邀请码
export function bindCode(params) {
  return request({
    url: "/api/web/user/bindCode",
    method: "post",
    data: params
  });
}

//登陆次数
export function addLoginCount(params) {
  return request({
    url: "/api/system/shopUser/addLoginCount",
    method: "post",
    data: params
  });
}



// WEBPACK FOOTER //
// ./src/api/login/index.js